import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router";
import { HelmetProvider } from "react-helmet-async";
import { Provider as AuthProvider } from "context/Auth";
import { Provider as IntlProvider } from "context/Intl";
import { Provider as FlashMessagesProvider } from "context/FlashMessages";
import { Provider as LoginDialogProvider } from "context/LoginDialog";
import { Provider as ForgotPasswordDialogProvider } from "context/ForgotPasswordDialog";
import { Provider as ProfileChoiceDialogProvider } from "context/ProfileChoiceDialog";
import FlashMessages from "components/App/FlashMessages";
import ErrorBoundary from "components/App/ErrorBoundary";
import Loader from "components/App/Loader";
import { Toaster } from "components/ui/sonner";
import ModuleRouter from "./ModuleRouter";
import ScrollToTop from "./ScrollToTop";
import LoginDialog from "./Authentication/LoginDialog";
import ForgotPasswordDialog from "./Authentication/ForgotPasswordDialog";
import ProfileChoiceDialog from "./Authentication/ProfileChoiceDialog";
import Landing from "./Landing";
import { Provider as BookingProvider } from "./OurService/Booking/Context";
import { Provider as NotificationProvider } from "app/Notification/Context";
import QueryProvider from "hooks/Provider";
import { ROUTES } from "routes";

import "../tailwind.css";
import "assets/icons";

const App: React.FC = () => {
    return (
        <HelmetProvider>
            <QueryProvider>
                <BrowserRouter basename={process.env.PUBLIC_URL} future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                    <ScrollToTop />
                    <Routes>
                        <Route path={`${ROUTES.LANDING}/*`} element={<Landing />} />
                        <Route
                            path="*"
                            element={
                                <AuthProvider>
                                    <NotificationProvider>
                                        <BookingProvider>
                                            <IntlProvider>
                                                <LoginDialogProvider>
                                                    <ForgotPasswordDialogProvider>
                                                        <ProfileChoiceDialogProvider>
                                                            <ErrorBoundary>
                                                                <FlashMessagesProvider FlashComponent={FlashMessages}>
                                                                    <Suspense fallback={<Loader />}>
                                                                        <ModuleRouter />
                                                                    </Suspense>
                                                                    <LoginDialog />
                                                                    <ForgotPasswordDialog />
                                                                    <ProfileChoiceDialog />
                                                                    <Toaster />
                                                                </FlashMessagesProvider>
                                                            </ErrorBoundary>
                                                        </ProfileChoiceDialogProvider>
                                                    </ForgotPasswordDialogProvider>
                                                </LoginDialogProvider>
                                            </IntlProvider>
                                        </BookingProvider>
                                    </NotificationProvider>
                                </AuthProvider>
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </QueryProvider>
        </HelmetProvider>
    );
};

export default App;
